import Vue from 'vue'
import store from '../vuex/index'
import Router from 'vue-router'
import layout from '../view/layout/layout'
import Home from '../view/Home/index'
import Product from '../view/Product/index'
import Information from '../view/Information/index'
import Informationmobile from '../view/Informationmobile/index'
import Informationhb from '../view/Informationhb/index'
import Informationmobilehb from '../view/Informationmobilehb/index'
import About from '../view/About/index'
import Join from '../view/Join/index'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/home',
      component: layout,
      meta: { title: '网站首页' },
      children: [
        {
          path: '/home',
          name: 'Home',
          meta: { title: '网站首页' },
          component: Home
        },
        {
          path: '/product',
          name: 'Product',
          meta: { title: '热销产品' },
          component: Product
        },
        {
          path: '/information',
          name: 'Information',
          meta: { title: '信息披露' },
          component: Information
        },
        {
          path: '/informationmobile',
          name: 'Informationmobile',
          meta: { title: '信息披露' },
          component: Informationmobile
        },
        {
          path: '/informationhb',
          name: 'Informationhb',
          meta: { title: '信息披露' },
          component: Informationhb
        },
        {
          path: '/informationmobilehb',
          name: 'Informationmobilehb',
          meta: { title: '信息披露' },
          component: Informationmobilehb
        },
        {
          path: '/about',
          name: 'About',
          meta: { title: '关于我们' },
          component: About
        },
        {
          path: '/join',
          name: 'Join',
          meta: { title: '加入我们' },
          component: Join
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name === 'Home') {
    store.commit('SET_ISPAGE', false)
  } else {
    store.commit('SET_ISPAGE', true)
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js